function getVideoForButton(btn) {
  // Prefer an explicit container, but gracefully fallback to "closest video".
  const root =
    btn.closest('[data-video-root]') ||
    btn.closest('.collection-list__media--video') ||
    btn.closest('[data-popular-video]') ||
    btn.parentElement;

  if (!root) return null;
  return root.querySelector('video');
}

function setButtonState(btn, isPlaying) {
  const pauseIcon = btn.querySelector('[data-video-toggle-icon="pause"]');
  const playIcon = btn.querySelector('[data-video-toggle-icon="play"]');

  if (pauseIcon) {
    pauseIcon.hidden = !isPlaying;
    pauseIcon.setAttribute('aria-hidden', isPlaying ? 'false' : 'true');
  }

  if (playIcon) {
    playIcon.hidden = isPlaying;
    playIcon.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
  }

  const title = btn.getAttribute('data-video-title');
  if (title) {
    btn.setAttribute('aria-label', isPlaying ? `Pause ${title} video` : `Play ${title} video`);
  } else {
    btn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }
}

async function toggleFromButton(btn) {
  let video = getVideoForButton(btn);

  // `lazy-video` may not have injected the <video> yet; retry once.
  if (!video) {
    await new Promise((r) => setTimeout(r, 0));
    video = getVideoForButton(btn);
  }

  if (!video) return;

  if (video.paused) {
    try {
      await video.play();
    } catch (_) {
      // ignore
    }
  } else {
    video.pause();
  }

  setButtonState(btn, !video.paused);
}

function syncButtonForVideo(videoEl) {
  if (!(videoEl instanceof HTMLVideoElement)) return;

  const root =
    videoEl.closest('[data-video-root]') ||
    videoEl.closest('.collection-list__media--video') ||
    videoEl.closest('[data-popular-video]');

  if (!root) return;

  const btn = root.querySelector('[data-video-toggle]');
  if (!btn) return;

  setButtonState(btn, !videoEl.paused);
}

document.addEventListener('click', (e) => {
  const btn = e.target?.closest?.('[data-video-toggle]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  toggleFromButton(btn);
});

// Keep button state in sync when videos autoplay / pause externally.
document.addEventListener(
  'play',
  (e) => {
    if (e.target && e.target.tagName === 'VIDEO') syncButtonForVideo(e.target);
  },
  true,
);
document.addEventListener(
  'pause',
  (e) => {
    if (e.target && e.target.tagName === 'VIDEO') syncButtonForVideo(e.target);
  },
  true,
);

// Best-effort initial sync for already-present videos.
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-video-toggle]').forEach((btn) => {
    const video = getVideoForButton(btn);
    if (!video) return;
    setButtonState(btn, !video.paused);
  });

  // `lazy-video` might inject after DOMContentLoaded; try again shortly.
  setTimeout(() => {
    document.querySelectorAll('[data-video-toggle]').forEach((btn) => {
      const video = getVideoForButton(btn);
      if (!video) return;
      setButtonState(btn, !video.paused);
    });
  }, 250);
});

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) return;
  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused) video.pause();
  });
});

